import React, { HTMLProps } from "react";

import { InputCheckSyle } from "./styles";

type CheckBoxFieldProps = HTMLProps<HTMLInputElement>;

const CheckBoxField = ({
  children,
  ...rest
}: CheckBoxFieldProps): JSX.Element => {
  return (
    <InputCheckSyle>
      <input type="checkbox" {...rest} />
      {children && <label htmlFor={rest.id}>{children}</label>}
    </InputCheckSyle>
  );
};

export default CheckBoxField;
